import React, { useEffect } from 'react';
import { sanitize } from 'utils/validation';
import { ANALYTICS } from 'constants';
import LoadingWidget from 'components/LoadingWidget';
import PrintButtonModal from 'components/Modal/PrintButtonModal';
import propTypes from './prePaymentTCRequestModalContentPropTypes';

const PrePaymentTermsAndConditionsModalContent = ({
  getPrepayTerms,
  prepayTerms,
  classNames = '',
  showPrintButton,
}) => {
  useEffect(() => {
    if (!prepayTerms) {
      getPrepayTerms();
    }
  }, [prepayTerms, getPrepayTerms]);

  return (
    <div className='modal-print__container padding-top--condensed'>
      {prepayTerms ? (
        <>
          <PrintButtonModal showPrintButton={showPrintButton} analyticsTitle={ANALYTICS.PREPAYMENT_TERMS_CONDITIONS} />
          <div className={classNames} dangerouslySetInnerHTML={sanitize(prepayTerms)} />
        </>
      ) : (
        <LoadingWidget />
      )}
    </div>
  );
};

PrePaymentTermsAndConditionsModalContent.propTypes = propTypes;

export default PrePaymentTermsAndConditionsModalContent;
